import React, { useState, useEffect } from 'react';
import { SdmDialog, SdmSpacer, SdmTypography } from 'components';
import { theme } from 'theme';
import {
  Checkbox,
  Grid,
  FormControl,
  FormGroup,
  FormLabel,
  FormControlLabel,
  TextField,
  withStyles,
} from '@material-ui/core';

import { useTheme } from '@material-ui/core/styles';
import useMediaQuery from '@material-ui/core/useMediaQuery';

const CustomFormTextField = withStyles({
  root: {
    '& label.Mui-focused': {
      color: `${theme.colors.primary.white}`,
    },
    '& .MuiInput-underline:after': {
      borderBottomColor: `${theme.colors.primary.white}`,
    },
    '& .MuiInput-underline:before': {
      borderBottom: `2px solid ${theme.colors.primary.white}`,
    },
    '& .MuiInput-underline:hover:not(.Mui-disabled):before': {
      borderBottom: `2px solid ${theme.colors.primary.white}`,
    },
    '& .MuiInputBase-input': {
      fontSize: 26,
      color: `${theme.colors.primary.white}`,
    },
    '& .MuiFormLabel-root': {
      color: `${theme.colors.primary.white}`,
    },
  },
})(TextField);

const CustomCheckbox = withStyles({
  checked: {
    color: theme.colors.primary.white,
  },
  colorPrimary: {
    color: theme.colors.primary.white,
    '&$checked': {
      color: theme.colors.primary.white,
    },
  },
})(Checkbox);

function DeleteInviteDialog({ onAgree, onClose, data, i18n }) {
  const [isAgreeEnabled, setIsAgreeDisabled] = useState(true);
  const [selectedCheckbox, setSelectedCheckbox] = useState();
  const [customMessage, setCustomMessage] = useState();
  const mediaTheme = useTheme();
  const isXsDown = useMediaQuery(mediaTheme.breakpoints.down('xs'));

  useEffect(() => {
    if (selectedCheckbox === 0 || selectedCheckbox) {
      if (selectedCheckbox === rejectMessages.length - 1) {
        setIsAgreeDisabled(!customMessage || customMessage === '');
      } else {
        setIsAgreeDisabled(false);
      }
    }
  }, [selectedCheckbox, customMessage]);

  const rejectMessages = [
    `${i18n.checkboxes.cannot}`,
    `${i18n.checkboxes.notInterested}`,
    `${i18n.checkboxes.newProposal}`,
    `${i18n.checkboxes.other}`,
  ];

  const renderTitle = () => {
    return (
      <div style={{ width: '100%' }}>
        <SdmTypography
          variant={'h2'}
          textAlign={'center'}
          margin={0}
          style={{ marginTop: 40, marginBottom: 0 }}
        >
          {i18n.title}
        </SdmTypography>

        <SdmTypography variant={'h5'} textAlign={'center'}>
          {i18n.subtitle}
        </SdmTypography>
      </div>
    );
  };

  const handleChange = (idx) => {
    setSelectedCheckbox(idx);
  };

  const getData = () => {
    const note =
      rejectMessages[selectedCheckbox] +
      (selectedCheckbox === rejectMessages.length - 1
        ? `: ${customMessage}`
        : '');
    return {
      ...data,
      note: note,
    };
  };
  return (
    <SdmDialog
      open
      onClose={onClose}
      title={renderTitle()}
      agreeText={i18n.send}
      hideAgreeButton={false}
      onAgreeDisabled={isAgreeEnabled}
      onAgree={() => onAgree(getData())}
      titleStyle={{ padding: 0 }}
      paperStyle={{
        borderRadius: 0,
        width: '628px !important',
        padding: isXsDown ? '10px 20px' : '10px 100px 30px',
        margin: 0,
        backgroundColor: theme.colors.primary.red,
        color: theme.colors.primary.white,
      }}
      closeIconContainerStyle={{
        top: 15,
        right: 20,
        transform: 'scale(1.5)',
      }}
      closeIconStyle={{ color: theme.colors.primary.white }}
      actionContainerStyle={{ justifyContent: 'center' }}
      actionVariant={'whiteFill'}
      actionStyle={{
        height: 47,
        width: 192,
        margin: 0,
      }}
      actionTextStyle={{ fontSize: 20 }}
      contentStyle={{
        paddingTop: 16,
        paddingBottom: 24,
        flex: 'none',
        margin: '0 auto',
      }}
      showTitleDivider={false}
    >
      <FormControl component="fieldset">
        <FormLabel
          style={{ color: theme.colors.primary.white }}
          component="legend"
        >
          {i18n.headLabel}
        </FormLabel>
        <FormGroup>
          <Grid container>
            {rejectMessages.map((message, idx) => {
              return (
                <Grid item key={idx} xs={12} sm={12} md={6} lg={6}>
                  <FormControlLabel
                    control={
                      <CustomCheckbox
                        color={'primary'}
                        checked={selectedCheckbox === idx}
                        onChange={() => handleChange(idx)}
                        name={message}
                      />
                    }
                    label={message}
                  />
                </Grid>
              );
            })}
            <SdmSpacer height={5} />
            <Grid item xs={12}>
              <CustomFormTextField
                fullWidth
                type="text"
                label={i18n.additionalNotes}
                disabled={
                  selectedCheckbox &&
                  selectedCheckbox != rejectMessages.length - 1
                }
                onFocus={() => {
                  handleChange(rejectMessages.length - 1);
                }}
                onChange={(e) => {
                  setCustomMessage(e.target.value);
                }}
              />
            </Grid>
          </Grid>
        </FormGroup>
      </FormControl>
    </SdmDialog>
  );
}

export default DeleteInviteDialog;
